<p>Configure connection to TermWeb</p>
<form [formGroup]="configForm" autocomplete="off">
  <input formControlName="id" type="hidden">
  <div class="row">
    <div class="col-sm">
      <mat-form-field id="url-field"
                      [matTooltip]="lockUrlClient ? lockedTooltip : ''"
                      [matTooltipDisabled]="!lockUrlClient"
                      matTooltipPosition="below"
                      data-testid="url-field">
        <mat-label>URL</mat-label>
        <input matInput formControlName="url">
        @if (configForm.get('url')?.hasError('required')) {
          <mat-error>URL is required</mat-error>
        }
        @if (configForm.get('url')?.hasError('pattern')) {
          <mat-error>Enter a valid URL</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-sm">
      <mat-form-field [matTooltip]="lockUrlClient ? lockedTooltip : ''"
                      [matTooltipDisabled]="!lockUrlClient"
                      matTooltipPosition="below"
                      data-testid="client-field">
        <mat-label>Client</mat-label>
        <input matInput formControlName="client">
        @if (configForm.get('client')?.hasError('required')) {
          <mat-error>Client is required</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-sm">
      <mat-form-field>
        <mat-label>User name</mat-label>
        <input matInput formControlName="userName" autocomplete="off">
        @if (configForm.get('userName')?.hasError('required')) {
          <mat-error>User name is required</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-sm">
      <mat-form-field>
        <mat-label data-testid="password-label">{{ passwordLabel }}</mat-label>
        <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" autocomplete="new-password">
        <button mat-icon-button matSuffix type="button"
                (click)="hidePassword = !hidePassword"
                [matTooltip]="hidePassword ? showPasswordTooltip : hidePasswordTooltip"
                [attr.aria-label]="hidePassword ? showPasswordTooltip : hidePasswordTooltip"
                [attr.aria-pressed]="!hidePassword"
                data-testid="password-visibility-toggle">
          <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        @if (configForm.get('password')?.hasError('required')) {
          <mat-error>Password is required</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  @if (showButtons) {
    <div class="button-container">
      <button mat-raised-button color="primary" (click)="save()" [disabled]="configForm.invalid">Save</button>
      <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
  }
</form>
